"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityUpdateGrouping = void 0;
const swap_buffer_layout_1 = require("./swap-buffer-layout");
/**
 * @public
 * A plain update grouping.
 */
class EntityUpdateGrouping {
    constructor(graphicsComponent, componentRenderer) {
        this.graphicsComponent = graphicsComponent;
        this.componentRenderer = componentRenderer;
    }
    drawUpdateGroup(entities, updateArg) {
        const componentRenderer = this.componentRenderer;
        const entityBufferStore = this.componentRenderer.sharedState.entityBuffers;
        const graphicsComponent = this.graphicsComponent;
        const groupId = graphicsComponent.transform.groupId;
        componentRenderer.onBeforeDraw();
        graphicsComponent.onBeforeUpdate(componentRenderer, updateArg);
        for (let i = 0, iEnd = entities.length; i < iEnd; ++i) {
            const entity = entities[i];
            if (entity.isFiltered) {
                continue;
            }
            const entityBufferLayout = entityBufferStore.getLayout(entity, groupId);
            (0, swap_buffer_layout_1.swapBufferLayout)(graphicsComponent, entityBufferLayout);
            graphicsComponent.update(entity, componentRenderer, updateArg);
            (0, swap_buffer_layout_1.swapBufferLayout)(graphicsComponent, entityBufferLayout);
        }
        componentRenderer.onAfterDraw();
    }
}
exports.EntityUpdateGrouping = EntityUpdateGrouping;
//# sourceMappingURL=entity-update-grouping.js.map